import { render, staticRenderFns } from "./FixedShopMap.vue?vue&type=template&id=5b2ab403&scoped=true"
import script from "./FixedShopMap.vue?vue&type=script&lang=js"
export * from "./FixedShopMap.vue?vue&type=script&lang=js"
import style0 from "./FixedShopMap.vue?vue&type=style&index=0&id=5b2ab403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ab403",
  null
  
)

export default component.exports